import React, { useState, useEffect } from "react";
import {
    Button, Card, Box, Select, MenuItem, FormControl, InputLabel,
    Grid, TextField, Typography, Checkbox, CardContent, CircularProgress
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AttendenceService from "./Locality/Service/attendenceService";
import StudentService from "./Locality/Service/studentService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";

const useStyles = makeStyles((theme) => ({
    container: {
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f4f6f8",
        padding: theme.spacing(3)
    },
    card: {
        width: "90%",
        maxWidth: "900px",
        padding: theme.spacing(3),
        boxShadow: theme.shadows[3],
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    studentRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: theme.spacing(1, 0),
        borderBottom: "1px solid #ddd"
    },
    submitButton: {
        marginTop: theme.spacing(2),
        backgroundColor: "#0f3b62",
        color: "white",
        '&:hover': {
            backgroundColor: "#0f3b62", // Keep it the same or set a custom hover color
        }
    },
    summaryWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "24px",
        marginTop: "32px",
        flexWrap: "wrap", // handles small screens
    },

    summaryCard: {
        padding: "16px",
        backgroundColor: "#f5faff",
        width: "200px",
        textAlign: "center",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        borderRadius: "12px",
    },

    presentText: {
        color: "green",
        fontWeight: "bold",
        fontSize: "24px",
    },

    absentText: {
        color: "red",
        fontWeight: "bold",
        fontSize: "24px",
    },

    summaryTitle: {
        fontSize: "18px",
        marginBottom: "8px",
        fontWeight: 600,
        color: "#0f3b62"
    }


}));

export default function Attendance() {
    const classes = useStyles();
    const [dateValue, setDateValue] = useState(new Date().toISOString().split("T")[0]);
    const [classValue, setClassValue] = useState("");
    const [sectionValue, setSectionValue] = useState("");
    const [sectionList, setSectionList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [absentStudentsList, setAbsentStudentsList] = useState([]);
const [showAbsentList, setShowAbsentList] = useState(false);
    const [todayAttendanceSummary, setTodayAttendanceSummary] = useState({attendenceReport:[]});
    var [classId, setClassId] = useState("");
    const [submitLoading, setSubmitLoading] = useState(false);
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    useEffect(() => {
        getAddClassList();
      //  getTodayAttendanceSummary();

    }, []);
    

    const getSectionListByClass = (classId) => {
        if (!classId) {
            setSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        }).then((res) => {
            let list = Array.isArray(res) ? res : [];
            setSectionList(list);
            if (list.length === 0) {
                setSectionValue("");
            } else if (userDetails.role === "TEACHER" && userDetails.sectionId) {
                setSectionValue(userDetails.sectionId);
            } else {
                setSectionValue("");
            }
        }).catch(() => {
            setSectionList([]);
            setSectionValue("");
        });
    };

    const fetchStudentList = (classId, newDate, sectionId) => {
        const today = newDate ? newDate : dateValue;
        const body = { classId };
        if (sectionId) body.sectionId = sectionId;
        StudentService.getAllStudentById(userDetails.schooleId, body).then((res) => {
            setStudentList(res.map(student => ({ ...student, status: true, lateComing: false, earlyGoing: false })));
            getTodayAttendanceSummary(classId, today, res, sectionId);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getAddClassList = () => {
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                const teacherClass = res.find(c => c._id === userDetails.classId);
                if (teacherClass) {
                    setAddClassList([teacherClass]);
                    setClassValue(teacherClass._id);
                    if (userDetails.sectionId) setSectionValue(userDetails.sectionId);
                    getSectionListByClass(teacherClass._id);
                    fetchStudentList(teacherClass._id, dateValue, userDetails.sectionId || undefined);
                }
            } else {
                setAddClassList(res);
            }
        }).catch((err) => {
            console.error(err);
        });
    };

const getStudentList = (event) => {
    const selectedClassId = event.target.value;
    setClassValue(selectedClassId);
    setSectionValue("");
    getSectionListByClass(selectedClassId);
    if (selectedClassId) {
        fetchStudentList(selectedClassId, dateValue, undefined);
    } else {
        setStudentList([]);
        setSectionList([]);
    }
};

const getSectionChange = (event) => {
    const selectedSectionId = event.target.value;
    setSectionValue(selectedSectionId);
    if (classValue) {
        fetchStudentList(classValue, dateValue, selectedSectionId || undefined);
    }
};

    const getTodayAttendanceSummary = (selectedClassId, selectedDate, studentList, sectionId) => {
        const keys = {
            schooleId: userDetails.schooleId,
            classId: selectedClassId,
            date: selectedDate || new Date().toISOString().split("T")[0]
        };
        if (sectionId) keys.sectionId = sectionId;

        AttendenceService.getTodaySummary(keys).then((res) => {
 
            setTodayAttendanceSummary(res);
const absentIds = (res.attendenceReport || [])
  .filter(s => s.status === false)
  .map(s => s.studentId);
              const updatedStudentList = studentList.map(student => ({
            ...student,
            status: !absentIds.includes(student._id)
        }));

        setStudentList(updatedStudentList);

        }).catch((err) => {
            console.error(err);
        });
    }
    const handleDateChange = (e) => {
  const newDate = e.target.value;
  setDateValue(newDate);
  if (classValue) {
    fetchStudentList(classValue, newDate, sectionValue || undefined);
  }
};
    const handleCheck = (studentId) => {
        setStudentList(prev => prev.map(student =>
            student._id === studentId ? { ...student, status: !student.status } : student
        ));
    };

    const handleLateComing = (studentId) => {
        setStudentList(prev => prev.map(student =>
            student._id === studentId ? { ...student, lateComing: !student.lateComing } : student
        ));
    };

    const handleEarlyGoing = (studentId) => {
        setStudentList(prev => prev.map(student =>
            student._id === studentId ? { ...student, earlyGoing: !student.earlyGoing } : student
        ));
    };

    const handleSubmit = () => {
        if (!classValue) {
            alert("Please select a class.");
            return;
        }
        const studentListPayload = studentList.map((student) => ({
            studentId: student._id,
            studentName: `${student.firstName || ""} ${student.lastName || ""}`.trim(),
            status: student.status,
            late: Boolean(student.lateComing),
            early: Boolean(student.earlyGoing),
        }));
        const attendanceData = {
            classId: classValue,
            schooleId: userDetails.schooleId,
            sectionId: sectionValue || undefined,
            studentList: studentListPayload,
            teacherId: userDetails._id,
            date: dateValue
        };
        setSubmitLoading(true);
        AttendenceService.creteAttendence(attendanceData).then(() => {
            setSubmitLoading(false);
            alert("Attendance Submitted Successfully");
            fetchStudentList(classValue, dateValue, sectionValue || undefined);
        }).catch(err => {
            setSubmitLoading(false);
            alert(err.response.data.message);
        });
    };

    return (
        <>

            <div >

                <Card className={classes.card}>
                    <Typography variant="h4" className={classes.title}>Attendance</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                label="Date"
                                type="date"
                                value={dateValue}
                                onChange={handleDateChange}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <InputLabel>Select Class</InputLabel>
                                <Select value={classValue} onChange={getStudentList}>
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <InputLabel>Select Section (Optional)</InputLabel>
                                <Select value={sectionValue} onChange={getSectionChange} disabled={!classValue || sectionList.length === 0}>
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {sectionList.map(({ _id, sectionName }) => (
                                        <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Typography variant="h6" style={{ marginTop: 20 }}>Student Details:</Typography>
                    {studentList.map((student) => (
                        <Box key={student._id} className={classes.studentRow}>
                            <Typography style={{ flex: 1 }}>
                                {student.firstName} {student.lastName}
                            </Typography>
                            <Box style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <Box style={{ display: "flex", alignItems: "center" }}>
                                    <Typography variant="body2" style={{ marginRight: 6 }}>P</Typography>
                                    <Checkbox checked={student.status} onChange={() => handleCheck(student._id)} />
                                </Box>
                                <Box style={{ display: "flex", alignItems: "center" }}>
                                    <Typography variant="body2" style={{ marginRight: 6 }}>Late</Typography>
                                    <Checkbox
                                        checked={Boolean(student.lateComing)}
                                        onChange={() => handleLateComing(student._id)}
                                        disabled={!student.status}
                                    />
                                </Box>
                                <Box style={{ display: "flex", alignItems: "center" }}>
                                    <Typography variant="body2" style={{ marginRight: 6 }}>Early</Typography>
                                    <Checkbox
                                        checked={Boolean(student.earlyGoing)}
                                        onChange={() => handleEarlyGoing(student._id)}
                                        disabled={!student.status}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    ))}
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            className={classes.submitButton}
                            onClick={handleSubmit}
                            disabled={submitLoading}
                        >
                            {submitLoading ? (
                                <>
                                    <CircularProgress size={18} style={{ marginRight: 8, color: 'white' }} />
                                    Submitting...
                                </>
                            ) : (
                                'Submit'
                            )}
                        </Button>
                    </div>
                </Card>
            </div>
            <br></br>
            <br></br>
            <br></br>
            <Grid container spacing={12}>
                {todayAttendanceSummary.attendenceReport.length>0 && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                            <div className={classes.summaryWrapper}>
                                <Card className={classes.summaryCard}>
                                    <CardContent>
                                        <Typography className={classes.summaryTitle}>Present</Typography>
                                        <Typography className={classes.presentText}>
                                            {todayAttendanceSummary.presentStudents}
                                        </Typography>
                                    </CardContent>
                                </Card>

                                <Card className={classes.summaryCard}>
                                    <CardContent>
                                        <Typography className={classes.summaryTitle}>Absent</Typography>
                                        <Typography className={classes.absentText}>
                                            {todayAttendanceSummary.absentStudents}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </div>

                        </Grid>
                    </Grid>
                )}

            </Grid>
        </>
    );
}
